import React, { Component } from 'react';

import RecentListItem from './RecentListItem';
import UnavailableListItem from './UnavailableListItem';

export default class List extends Component {
  state = {
    removeInfo: false,
    selectedItem: null,
  };
  render() {
    const {
      recentFavorites,
      unavailableFavorites,
      edit,
      handleSelectItem,
      selectedItems,
      handleRemoveSelected,
    } = this.props;

    return (
      <div className="">
        {(recentFavorites.length && (
          <div className="white-bg favorite-list mt-10px">
            <h4>Recently Added</h4>
            {recentFavorites.map(item => (
              <RecentListItem
                key={item.uid}
                item={item}
                edit={edit}
                selectedItems={selectedItems}
                handleRemove={handleRemoveSelected}
                handleSelectItem={handleSelectItem}
              />
            ))}
          </div>
        )) || <noscript />}
        {(unavailableFavorites.length && (
          <div className="white-bg favorite-list offline mt-10px">
            <h4>Currently Unavailable</h4>
            {unavailableFavorites.map(item => (
              <UnavailableListItem
                key={item.uid}
                item={item}
                edit={edit}
                selectedItems={selectedItems}
                handleRemove={handleRemoveSelected}
                handleSelectItem={handleSelectItem}
              />
            ))}
          </div>
        )) || <noscript />}
      </div>
    );
  }
}
